import type { FC } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export const NavigateWithUrlSearchParams: FC<{ to: string }> = ({ to }) => {
  const location = useLocation();

  return <Navigate to={`${to}${location.search}`} replace />;
};
